import React, { useState, useEffect } from "react";
import "./stats.scss";
import { DateRange } from "react-date-range";
import moment from "moment";
import { Api_Url } from "../../../utils/ApiUrl";
import axios from "axios";
import CurrentRound from "../../../hooks/dataFetchers/round";

const Stats = ({ usdPrice }) => {
  const val = localStorage.getItem("accessToken");
  const { currentRound } = CurrentRound();

  const [showcalendar, setShowCalendar] = useState(false);
  const [alllset, setalllset] = useState("all");
  const [round, setRound] = useState("");
  const [totalRound, setTotalRound] = useState([]);
  const [profitChange, setProfitChange] = useState("0");
  const [buybackChange, setBuybackChange] = useState("0");

  const [statsData, setStatsData] = useState({});
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    formatDates("");
    firstTimeData();
  }, []);

  const getStatsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/platform-stats`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `?startDate=${startDate}&endDate=${endDate}`;
    }
    if (startDate && startDate != null && round) {
      dynamicQuery += `&round=${round}`;
    } else if (round) {
      dynamicQuery += `?round=${round}`;
    }
    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        const resData = response?.data?.data?.data;
        const oldProfit = resData?.oldNetProfitDollars;
        const newProfit = resData?.netProfitDollars;
        let profitChangeTemp = 0;
        if (newProfit === 0 && oldProfit === 0) {
          profitChangeTemp = 0;
        } else if (newProfit === 0 || oldProfit === 0) {
          if (newProfit === 0) {
            profitChangeTemp = ((0 - oldProfit) / oldProfit) * 100;
          }
          if (oldProfit === 0) {
            profitChangeTemp = ((newProfit + 1 - 1) / 1) * 100;
          }
        } else {
          profitChangeTemp = ((newProfit - oldProfit) / oldProfit) * 100;
        }
        setProfitChange(profitChangeTemp);

        let oldBuyback = 0;
        if (resData?.oldBuyBack?.length > 0) {
          oldBuyback =
            resData?.oldBuyBack[0]?.totalEth * usdPrice +
            resData?.oldBuyBack[0]?.totalUsdt +
            resData?.oldBuyBack[0]?.totalUsdc;
        }
        let newBuyback = 0;
        if (resData?.buyBack?.length > 0) {
          newBuyback =
            resData?.buyBack[0]?.totalEth * usdPrice +
            resData?.buyBack[0]?.totalUsdt +
            resData?.buyBack[0]?.totalUsdc;
        }

        let buyBackChangeTemp = 0;
        if (newBuyback === 0 && oldBuyback === 0) {
          buyBackChangeTemp = 0;
        } else if (newBuyback === 0 || oldBuyback === 0) {
          if (newBuyback === 0) {
            buyBackChangeTemp = ((0 - oldBuyback) / oldBuyback) * 100;
          }
          if (oldBuyback === 0) {
            buyBackChangeTemp = ((newBuyback + 1 - 1) / 1) * 100;
          }
        } else {
          buyBackChangeTemp = ((newBuyback - oldBuyback) / oldBuyback) * 100;
        }
        setBuybackChange(buyBackChangeTemp);

        setStatsData(resData);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  useEffect(() => {
    if (val && val !== null) {
      getStatsData();
    }
  }, [startDate, endDate, round]);

  const firstTimeData = async () => {
    try {
      let b = await currentRound();

      if (b) {
        const result = [];
        for (let i = 1; i <= b; i++) {
          result.push(i);
        }
        setTotalRound(result);
      }
    } catch (err) {
      // console.log(err.message);
    }
  };

  const formatDates = (times) => {
    let date = null;
    let date1 = null;
    if (Array.isArray(times)) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");
    } else if (times == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    setStartDate(date);
    setEndDate(date1);
  };
  return (
    <>
      <section className="dashboard stats-section">
        <div className="custom-container">
          <div className="mainbuttonsss">
            <div className="main-heading m-0">
              <h6>Stats</h6>
            </div>
            <div className="parent-twice-custom">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {round == "" ? "All Rounds" : "Round " + round}
                  <img
                    src="\assets\arrow-down.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setRound("");
                      }}
                    >
                      All Rounds
                    </a>
                  </li>
                  {totalRound?.map((elem, index) => {
                    return (
                      <li
                        onClick={() => {
                          setRound(index + 1);
                        }}
                      >
                        <a class="dropdown-item" href="#">
                          Round {index + 1}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="custom-tab-bar">
                <a
                  onClick={() => {
                    setalllset("1");
                    formatDates("1");
                  }}
                  className={alllset == "1" ? "active" : "noactive"}
                >
                  1D
                </a>
                <a
                  onClick={() => {
                    setalllset("seven");
                    formatDates("seven");
                  }}
                  className={alllset == "seven" ? "active" : "noactive"}
                >
                  7D
                </a>
                <a
                  onClick={() => {
                    setalllset("month");
                    formatDates("month");
                  }}
                  className={alllset == "month" ? "active" : "noactive"}
                >
                  1M
                </a>
                <a
                  onClick={() => {
                    setalllset("year");
                    formatDates("year");
                  }}
                  className={alllset == "year" ? "active" : "noactive"}
                >
                  1Y
                </a>
                <a
                  onClick={() => {
                    setalllset("all");
                    formatDates("");
                  }}
                  className={alllset == "all" ? "active" : "noactive"}
                >
                  All
                </a>
                <a onClick={() => setShowCalendar(!showcalendar)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M17.0831 3.56V2C17.0831 1.59 16.7431 1.25 16.3331 1.25C15.9231 1.25 15.5831 1.59 15.5831 2V3.5H9.08312V2C9.08312 1.59 8.74311 1.25 8.33312 1.25C7.92312 1.25 7.58312 1.59 7.58312 2V3.56C4.88312 3.81 3.57311 5.42 3.37311 7.81C3.35311 8.1 3.59311 8.34 3.87311 8.34H20.7931C21.0831 8.34 21.3231 8.09 21.2931 7.81C21.0931 5.42 19.7831 3.81 17.0831 3.56Z"
                      fill="#8C8C8C"
                    />
                    <path
                      d="M20.3331 9.83984H4.33313C3.78313 9.83984 3.33313 10.2898 3.33313 10.8398V16.9998C3.33313 19.9998 4.83313 21.9998 8.33313 21.9998H16.3331C19.8331 21.9998 21.3331 19.9998 21.3331 16.9998V10.8398C21.3331 10.2898 20.8831 9.83984 20.3331 9.83984ZM9.54313 18.2098C9.49313 18.2498 9.44313 18.2998 9.39313 18.3298C9.33313 18.3698 9.27313 18.3998 9.21313 18.4198C9.15313 18.4498 9.09313 18.4698 9.03313 18.4798C8.96313 18.4898 8.90313 18.4998 8.83313 18.4998C8.70313 18.4998 8.57313 18.4698 8.45313 18.4198C8.32313 18.3698 8.22313 18.2998 8.12313 18.2098C7.94313 18.0198 7.83313 17.7598 7.83313 17.4998C7.83313 17.2398 7.94313 16.9798 8.12313 16.7898C8.22313 16.6998 8.32313 16.6298 8.45313 16.5798C8.63313 16.4998 8.83313 16.4798 9.03313 16.5198C9.09313 16.5298 9.15313 16.5498 9.21313 16.5798C9.27313 16.5998 9.33313 16.6298 9.39313 16.6698C9.44313 16.7098 9.49313 16.7498 9.54313 16.7898C9.72313 16.9798 9.83313 17.2398 9.83313 17.4998C9.83313 17.7598 9.72313 18.0198 9.54313 18.2098ZM9.54313 14.7098C9.35313 14.8898 9.09313 14.9998 8.83313 14.9998C8.57313 14.9998 8.31313 14.8898 8.12313 14.7098C7.94313 14.5198 7.83313 14.2598 7.83313 13.9998C7.83313 13.7398 7.94313 13.4798 8.12313 13.2898C8.40313 13.0098 8.84313 12.9198 9.21313 13.0798C9.34313 13.1298 9.45313 13.1998 9.54313 13.2898C9.72313 13.4798 9.83313 13.7398 9.83313 13.9998C9.83313 14.2598 9.72313 14.5198 9.54313 14.7098ZM13.0431 18.2098C12.8531 18.3898 12.5931 18.4998 12.3331 18.4998C12.0731 18.4998 11.8131 18.3898 11.6231 18.2098C11.4431 18.0198 11.3331 17.7598 11.3331 17.4998C11.3331 17.2398 11.4431 16.9798 11.6231 16.7898C11.9931 16.4198 12.6731 16.4198 13.0431 16.7898C13.2231 16.9798 13.3331 17.2398 13.3331 17.4998C13.3331 17.7598 13.2231 18.0198 13.0431 18.2098ZM13.0431 14.7098C12.9931 14.7498 12.9431 14.7898 12.8931 14.8298C12.8331 14.8698 12.7731 14.8998 12.7131 14.9198C12.6531 14.9498 12.5931 14.9698 12.5331 14.9798C12.4631 14.9898 12.4031 14.9998 12.3331 14.9998C12.0731 14.9998 11.8131 14.8898 11.6231 14.7098C11.4431 14.5198 11.3331 14.2598 11.3331 13.9998C11.3331 13.7398 11.4431 13.4798 11.6231 13.2898C11.7131 13.1998 11.8231 13.1298 11.9531 13.0798C12.3231 12.9198 12.7631 13.0098 13.0431 13.2898C13.2231 13.4798 13.3331 13.7398 13.3331 13.9998C13.3331 14.2598 13.2231 14.5198 13.0431 14.7098ZM16.5431 18.2098C16.3531 18.3898 16.0931 18.4998 15.8331 18.4998C15.5731 18.4998 15.3131 18.3898 15.1231 18.2098C14.9431 18.0198 14.8331 17.7598 14.8331 17.4998C14.8331 17.2398 14.9431 16.9798 15.1231 16.7898C15.4931 16.4198 16.1731 16.4198 16.5431 16.7898C16.7231 16.9798 16.8331 17.2398 16.8331 17.4998C16.8331 17.7598 16.7231 18.0198 16.5431 18.2098ZM16.5431 14.7098C16.4931 14.7498 16.4431 14.7898 16.3931 14.8298C16.3331 14.8698 16.2731 14.8998 16.2131 14.9198C16.1531 14.9498 16.0931 14.9698 16.0331 14.9798C15.9631 14.9898 15.8931 14.9998 15.8331 14.9998C15.5731 14.9998 15.3131 14.8898 15.1231 14.7098C14.9431 14.5198 14.8331 14.2598 14.8331 13.9998C14.8331 13.7398 14.9431 13.4798 15.1231 13.2898C15.2231 13.1998 15.3231 13.1298 15.4531 13.0798C15.6331 12.9998 15.8331 12.9798 16.0331 13.0198C16.0931 13.0298 16.1531 13.0498 16.2131 13.0798C16.2731 13.0998 16.3331 13.1298 16.3931 13.1698C16.4431 13.2098 16.4931 13.2498 16.5431 13.2898C16.7231 13.4798 16.8331 13.7398 16.8331 13.9998C16.8331 14.2598 16.7231 14.5198 16.5431 14.7098Z"
                      fill="#8C8C8C"
                    />
                  </svg>
                </a>
                {/* {showcalendar && ( */}
                {showcalendar && (
                  <div className="cal set-custom-calendar-div">
                    <DateRange
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      onChange={(item) => {
                        setState([item.selection]);
                        formatDates([item.selection]);
                      }}
                      ranges={state}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="main-cards">
            <div className="single-card">
              <div className="inner-parent">
                <div className="left-img">
                  <img
                    src="\assets\stats\premiumleader.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </div>
                <div className="right-stats">
                  <p>Premium Leaders</p>
                  <h6>
                    {statsData?.premiumLeadersCount?.toLocaleString()}{" "}
                    {/* <span className="green">+0.8%</span> */}
                  </h6>
                </div>
              </div>
              <div className="bottom-value">
                <p>
                  <span></span>
                  {statsData?.leaderStakedTokenCount?.toLocaleString()} GEMS
                  Locked
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="left-img">
                  <img
                    src="\assets\stats\goldenuser.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </div>
                <div className="right-stats">
                  <p>Golden Users</p>
                  <h6>
                    {(
                      statsData?.totalUserStakedGems -
                      statsData?.premiumLeadersCount
                    )?.toLocaleString()}{" "}
                    {/* <span className="green">+0.8%</span> */}
                  </h6>
                </div>
              </div>
              <div className="bottom-value">
                <p>
                  <span></span>
                  {(
                    statsData?.totalGemsStaked -
                    statsData?.leaderStakedTokenCount
                  )?.toLocaleString()}{" "}
                  GEMS Locked
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="left-img">
                  <img
                    src="\assets\stats\gemsnetprofit.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </div>
                <div className="right-stats">
                  <p>Gems Net Profit</p>
                  <h6>
                    ~${statsData?.netProfitDollars?.toLocaleString()}{" "}
                    {profitChange >= 0 ? (
                      <span className="green">+{profitChange}%</span>
                    ) : (
                      <span className="red">-{profitChange}%</span>
                    )}
                  </h6>
                </div>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="left-img">
                  <img
                    src="\assets\stats\buyback.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </div>
                <div className="right-stats">
                  <p>Buy backs</p>
                  <h6>
                    {statsData?.buybackCount?.toLocaleString()}
                    {buybackChange >= 0 ? (
                      <span className="green">
                        +{parseFloat(buybackChange)?.toFixed(2)}%
                      </span>
                    ) : (
                      <span className="red">
                        -{parseFloat(buybackChange)?.toFixed(2)}%
                      </span>
                    )}
                  </h6>
                </div>
              </div>
              <div className="bottom-value">
                {statsData?.buyBack?.length > 0 ? (
                  <p>
                    <span></span>$
                    {(
                      statsData?.buyBack[0]?.totalEth * usdPrice +
                      statsData?.buyBack[0]?.totalUsdt +
                      statsData?.buyBack[0]?.totalUsdc
                    )?.toLocaleString()}
                  </p>
                ) : (
                  <p>
                    <span></span>$ 0
                  </p>
                )}
              </div>
              <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_5931_11046)">
                      <circle cx="10.6665" cy="10" r="10" fill="#E6E5E5" />
                      <path
                        d="M13.9997 8.33325L10.6663 11.6666L7.33301 8.33325"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_5931_11046">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.666504)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
                <ul class="dropdown-menu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.buyBack?.length > 0 ? (
                      <h6>
                        {parseFloat(statsData?.buyBack[0]?.totalEth)?.toFixed(5)}{" "}
                        ETH
                      </h6>
                    ) : (
                      <h6>0 ETH</h6>
                    )}
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.buyBack?.length > 0 ? (
                      <h6>
                        {parseFloat(statsData?.buyBack[0]?.totalUsdt)
                          .toFixed(2)
                          ?.toLocaleString()}{" "}
                        USDT
                      </h6>
                    ) : (
                      <h6>0 USDT</h6>
                    )}
                  </div>

                  <div className="text">
                    <p>USDC</p>
                    {statsData?.buyBack?.length > 0 ? (
                      <h6>
                        {parseFloat(statsData?.buyBack[0]?.totalUsdc)
                          .toFixed(2)
                          ?.toLocaleString()}{" "}
                        USDC
                      </h6>
                    ) : (
                      <h6>0 USDC</h6>
                    )}
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Stats;
